import React from 'react';

const DressCodePage: React.FC = () => {
    const amenities = [
        { icon: '/images/Icono-08.png', name: 'Vestido largo' },
        { icon: "/images/Icono-07.png", name: 'Traje con corbata o moño' }
    ];

    return (
        <div className="bg-[url('assets/images/GreenTile.png')] text-white bg-center bg-repeat bg-size-[auto_200px]">
            <div className="md:max-w-[40svw] mx-auto">
                <div className="flex flex-col justify-center items-center mx-4">
                    <p className="text-[16pt] md:text-[20pt] text-center font-extralight pt-20">Código de Vestimenta</p>
                    <img alt="Title" src="/images/Title-DressCode.png" className="mt-3 md:mt-8 -mb-4"/>
                    <section className="pt-[120px] md:-mb-18 -mt-20">
                        <div className="container mx-auto">
                            <div className="flex place-content-center overflow-x-auto pb-4 scrollbar-hide">
                                {amenities.map((amenity, index) => (
                                    <div key={index} className="flex-column w-32 text-center mx-3 ">
                                        <div className=" h-40 w-28 flex-column content-center bg-[#4c654d] rounded-full p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
                                            <img src={amenity.icon} alt={amenity.name}></img>
                                            <div className="text-[#171e17] mt-2 text-sm/[18px] flex flex-col justify-center">{amenity.name}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>
                    <p className="text-2xl text-center mt-10 md:mt-20 font-bold">Paleta de color</p>
                    <p className="text-center mt-4">Tonos oscuros, profundos y elegantes, inspirados en la montaña y naturaleza. Colores como <strong>verdes oliva y bosque, borgoña, vino, café, chocolate, negro, camel, mostaza y dorados apagados</strong> son ideales. ¡Estos tonos van acorde a la atmósfera que buscamos para nuestro evento!</p>
                    <img alt="Title" src="/images/Do-color.png" className="mt-8 -mb-4 w-3/4"/>
                    <img alt="Title" src="/images/DressCode-colors.png" className="mt-8 -mb-4"/>
                    <p className="text-2xl text-center mt-18 font-bold">Colores NO permitidos</p>
                    <p className="text-center mt-4">Les pedimos evitar <strong>colores claros y suaves como blanco, beige y tonos pastel, así como toda la gama de azules y tonos terracota</strong>. Agradecemos elegir colores oscuros y profundos que complementen la atmósfera formal y natural del evento.</p>
                    <img alt="Title" src="/images/Dont-color.png" className="mt-8 -mb-4 w-3/4"/>
                    <img alt="Title" src="/images/DressCode-dont.png" className="mt-8 -mb-4"/>
                    <p className="text-2xl text-center mt-14 font-bold leading-7">Consideraciones<br/>y sugerencias</p>
                    <img alt="Consideraciones" src="/images/DressCode.png" className="mb-8"/>

                </div>
            </div>
        </div>
    );
};

export default DressCodePage;